var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2679 6.20748C13.9682 5.92148 13.4935 5.93252 13.2075 6.23214C12.9215 6.53177 12.9325 7.00651 13.2321 7.29252L17.3781 11.25H4.75C4.33579 11.25 4 11.5858 4 12C4 12.4142 4.33579 12.75 4.75 12.75H17.3781L13.2321 16.7075C12.9325 16.9935 12.9215 17.4682 13.2075 17.7679C13.4935 18.0675 13.9682 18.0785 14.2679 17.7925L19.7679 12.5425C19.9161 12.401 20 12.205 20 12C20 11.795 19.9161 11.599 19.7679 11.4575L14.2679 6.20748Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0b0ecdda37ddc7d8178786e3d3237be2.svg";
export { ForwardRef as ReactComponent };